import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { TranslationService } from '../../../core/services/translation.service';

@Component({
  selector: 'app-legal-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './legal-modal.component.html',
  styleUrls: ['./legal-modal.component.scss']
})
export class LegalModalComponent implements OnInit {
  @Input() title: string = '';
  @Input() content: string = '';
  @Output() closeModal = new EventEmitter<void>();
  
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private translationService: TranslationService
  ) {}

  ngOnInit(): void {
    // Prevent scrolling when modal is open
    if (typeof document !== 'undefined') {
      document.body.style.overflow = 'hidden';
    }
    
    // Add event listener to close modal when clicking outside
    setTimeout(() => {
      const modalBackdrop = this.el.nativeElement.querySelector('.modal-backdrop');
      if (modalBackdrop) {
        this.renderer.listen(modalBackdrop, 'click', (event: MouseEvent) => {
          if (event.target === modalBackdrop) {
            this.close();
          }
        });
      }
    });
  }

  close(): void {
    // Re-enable scrolling
    if (typeof document !== 'undefined') {
      document.body.style.overflow = '';
    }
    this.closeModal.emit();
  }

  // Method to translate text
  translate(key: string): string {
    return this.translationService.translate(key);
  }
}
